import React from 'react';
import AdobePluginInstallInstructions from './adobe-plugin';

export default function PhotoshopInstallInstructions() {
  return (
    <AdobePluginInstallInstructions
      productName="Adobe Photoshop"
      ccxHref="/cc-plugins/photoshop.ccx"
      downloadFileName="StreamWork Photoshop Plugin.ccx"
      openMenuPath={
        <>
          <strong>Plugins &gt; StreamWork</strong> (or{' '}
          <strong>Window &gt; Plugins (Beta) &gt; StreamWork</strong>, depending
          on your Photoshop version)
        </>
      }
    />
  );
}
